<a [routerLink]="link" class="brand-logo-link" [class.dark]="darkBg">
  @if (tenant.logo_url || tenant.dark_logo_url) {
    @if (darkBg) {
      <img [src]="tenant.dark_logo_url || tenant.logo_url" alt="" class="brand-logo" />
    } @else {
      <img [src]="tenant.logo_url || tenant.dark_logo_url" alt="" class="brand-logo" />
    }
  } @else {
    <div class="brand-name" [class.small]="small">{{ tenant.name || 'Picflow User' }}</div>
  }
</a>
<div class="socials">
  @if (tenant.contacts?.site) {
    <a
      appButton
      name="website"
      location="tenant-profile-page"
      color="simple-gray"
      [iconButton]="true"
      shape="round"
      class="social"
      height="1"
      appTooltip="{{ niceSite(tenant.contacts.site) }}"
      rel="nofollow noreferrer noopener"
      [href]="tenant.contacts.site"
      target="_blank"
    >
      <app-svg src="/assets/icons/globe.svg"></app-svg>
    </a>
  }
  @if (tenant.contacts.phone) {
    <a
      appButton
      name="phone"
      location="tenant-profile-page"
      color="simple-gray"
      [iconButton]="true"
      shape="round"
      class="social"
      height="1"
      appTooltip="{{ tenant.contacts.phone }}"
      rel="nofollow noreferrer noopener"
      [href]="'tel:' + tenant.contacts.phone"
      target="_blank"
    >
      <app-svg src="/assets/icons/phone.svg"></app-svg>
    </a>
  }
  @if (tenant.contacts.email) {
    <a
      appButton
      name="email"
      location="tenant-profile-page"
      color="simple-gray"
      [iconButton]="true"
      shape="round"
      class="social"
      height="1"
      appTooltip="{{ tenant.contacts.email }}"
      rel="nofollow noreferrer noopener"
      [href]="'mailto:' + tenant.contacts.email"
      target="_blank"
    >
      <app-svg src="/assets/icons/email.svg"></app-svg>
    </a>
  }
  @if (tenant.socials.facebook) {
    <a
      appButton
      name="facebook"
      location="tenant-profile-page"
      color="simple-gray"
      [iconButton]="true"
      shape="round"
      class="social"
      height="1"
      rel="nofollow noreferrer noopener"
      [href]="'https://www.facebook.com/' + tenant.socials.facebook"
      target="_blank"
    >
      <app-svg src="/assets/icons/logo/facebook.svg"></app-svg>
    </a>
  }
  @if (tenant.socials.instagram) {
    <a
      appButton
      name="instagram"
      location="tenant-profile-page"
      color="simple-gray"
      [iconButton]="true"
      shape="round"
      class="social"
      height="1"
      rel="nofollow noreferrer noopener"
      [href]="'https://www.instagram.com/' + tenant.socials.instagram"
      target="_blank"
    >
      <app-svg src="/assets/icons/logo/instagram.svg"></app-svg>
    </a>
  }
  @if (tenant.socials.twitter) {
    <a
      appButton
      name="twitter"
      location="tenant-profile-page"
      color="simple-gray"
      [iconButton]="true"
      shape="round"
      class="social"
      height="1"
      rel="nofollow noreferrer noopener"
      [href]="'https://twitter.com/' + tenant.socials.twitter"
      target="_blank"
    >
      <app-svg src="/assets/icons/logo/twitter.svg"></app-svg>
    </a>
  }
  @if (tenant.socials.linkedIn) {
    <a
      appButton
      name="linkedin"
      location="tenant-profile-page"
      color="simple-gray"
      [iconButton]="true"
      shape="round"
      class="social"
      height="1"
      rel="nofollow noreferrer noopener"
      [href]="'https://www.linkedin.com/company/' + tenant.socials.linkedIn"
      target="_blank"
    >
      <app-svg src="/assets/icons/logo/linkedin.svg"></app-svg>
    </a>
  }
  @if (tenant.socials.pinterest) {
    <a
      appButton
      name="pinterest"
      location="tenant-profile-page"
      color="simple-gray"
      [iconButton]="true"
      shape="round"
      class="social"
      height="1"
      rel="nofollow noreferrer noopener"
      [href]="'https://www.pinterest.com/' + tenant.socials.pinterest"
      target="_blank"
    >
      <app-svg src="/assets/icons/logo/pinterest.svg"></app-svg>
    </a>
  }
  @if (tenant.socials.tiktok) {
    <a
      appButton
      name="tiktok"
      location="tenant-profile-page"
      color="simple-gray"
      [iconButton]="true"
      shape="round"
      class="social"
      height="1"
      rel="nofollow noreferrer noopener"
      [href]="'https://tiktok.com/@' + tenant.socials.tiktok"
      target="_blank"
    >
      <app-svg src="/assets/icons/logo/tiktok.svg"></app-svg>
    </a>
  }
  @if (tenant.socials.youtube) {
    <a
      appButton
      name="youtube"
      location="tenant-profile-page"
      color="simple-gray"
      [iconButton]="true"
      shape="round"
      class="social"
      height="1"
      rel="nofollow noreferrer noopener"
      [href]="'https://youtube.com/@' + tenant.socials.youtube"
      target="_blank"
    >
      <app-svg src="/assets/icons/logo/youtube.svg"></app-svg>
    </a>
  }
</div>
